var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 26,
    viewBox: "0 0 21 26",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.5238095 1.42857143c.2629928 0 .4761905.21319774.4761905.47619047v2.38095239h-20v-2.38095239c0-.26299273.21319774-.47619047.47619048-.47619047h4.84285714l.80952381-1.21428572c.08761118-.13304057.23594329-.21346159.39523809-.21428571h6.95238098c.1592948.00082412.3076269.08124514.3952381.21428571l.8095238 1.21428572zm-18.09523807 21.42857147v-17.14285719h17.14285717v17.14285719c0 1.5779564-1.2791865 2.8571428-2.8571429 2.8571428h-11.42857141c-1.57795643 0-2.85714286-1.2791864-2.85714286-2.8571428z",
    fill: "#E3215F",
    transform: "translate(.353427 -.043135)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.f4ae93a9e45cb343f805a9c4f557d353.svg";
export { ForwardRef as ReactComponent };